import React from "react";

export const PlusIcon = ({ className }: { className?: string}) => (
  <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M8.7957 1.12128V15.817M16.1966 8.54842H1.52734" stroke="black" strokeOpacity="0.8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
